import { createSelector } from 'reselect';

import { getCoworkingOperator } from './getCoworkingOperator';

export const getCoworkingOperatorId = createSelector(getCoworkingOperator, operator => operator?.cianId || 0);
